export enum Limits {
    YEAR = 'YEAR',
    MONTH = 'MONTH',
    DAY = 'DAY',
    HOUR = 'HOUR',
    MINUTE = 'MINUTE',
    SECOND = 'SECOND',
}
